<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile
                @click="printAllLayoutSettingList('printAllLayoutSettingList')"
              >
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllLayoutSetting()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="layoutTypes"
                label="Layout Type"
                v-model="queryParams.layoutType"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                v-model="queryParams.sessionName"
                :items="sessionList"
                label="Session..."
                item-text="label"
                menu-props="auto"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="layoutSettingList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>
                <v-icon
                  v-if="props.item.status == 'ACTIVE'"
                  medium
                  color="green"
                  >check_circle</v-icon
                >
                <v-icon v-else medium color="red">cancel</v-icon>
              </td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.layoutType }}</td>
              <td>{{ props.item.sessionName }}</td>
              <td>
                {{
                  props.item.updatedDateInMilliSeconds
                    | format-ms-date-time
                }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!--print all layout setting-->
    <div
      id="printAllLayoutSettingList"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center; padding-bottom: 5px">
        <p style="font-size: 15px; margin: 0px">Layout Settings</p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">Code</th>
              <th style="border: 1px solid black; text-align: center">Name</th>
              <th style="border: 1px solid black; text-align: center">
                Description
              </th>
              <th style="border: 1px solid black; text-align: center">
                Layout Type
              </th>
              <th style="border: 1px solid black; text-align: center">
                Session Name
              </th>
              <th style="border: 1px solid black; text-align: center">
                Status
              </th>
              <th style="border: 1px solid black; text-align: center">
                Account Code
              </th>
              <th style="border: 1px solid black; text-align: center">
                Account Name
              </th>
              <th style="border: 1px solid black; text-align: center">
                Is Subtract
              </th>
              <th style="border: 1px solid black; text-align: center">
                Previous Trial
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(layoutSettingPrint, index) in allLayoutSettingList"
            :key="index"
          >
            <tr
              v-for="(item, i) in layoutSettingPrint.layoutSettingPrintList"
              :key="i"
            >
              <td
                v-if="i == 0"
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
                v-bind:rowspan="
                  layoutSettingPrint.layoutSettingPrintList.length
                "
              >
                {{ item.code }}
              </td>
              <td
                v-if="i == 0"
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
                v-bind:rowspan="
                  layoutSettingPrint.layoutSettingPrintList.length
                "
              >
                {{ item.name }}
              </td>
              <td
                v-if="i == 0"
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
                v-bind:rowspan="
                  layoutSettingPrint.layoutSettingPrintList.length
                "
              >
                {{ item.description }}
              </td>
              <td
                v-if="i == 0"
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
                v-bind:rowspan="
                  layoutSettingPrint.layoutSettingPrintList.length
                "
              >
                {{ item.layoutType }}
              </td>
              <td
                v-if="i == 0"
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
                v-bind:rowspan="
                  layoutSettingPrint.layoutSettingPrintList.length
                "
              >
                {{ item.sessionName }}
              </td>
              <td
                v-if="i == 0"
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
                v-bind:rowspan="
                  layoutSettingPrint.layoutSettingPrintList.length
                "
              >
                {{ item.status }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.accountCode }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.accountName }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.isSubtract }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.isPreviousTrial }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>
<script>
import { commonService } from "../../services/common-service";
import { layoutSettingService } from "../../services/layout-setting-service";
export default {
  name: "LayoutSettingList",
  components: {},
  data: () => ({
    buttonLoading: false,
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "Layout Setting",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Status", value: "status" },
      { text: "Code", align: "left", value: "code" },
      { text: "Name", value: "name" },
      { text: "Description", value: "description" },
      { text: "Layout Type", value: "layoutType" },
      { text: "Session Name", value: "sessionName" },
      { text: "Updated Date", value: "createdDate" },
      { text: "Updated By", value: "createdBy" },
    ],
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" },
    ],
    layoutTypes: [
      { label: "All", value: "" },
      { label: "Income Statement", value: "INCOME_STATEMENT" },
      { label: "Balance Sheet", value: "BALANCE_SHEET" },
    ],
    sessionList: [
      { label: "All", value: "" },
      { label: "Revenue", value: "REVENUE" },
      { label: "Cost of Good Sold", value: "COST_OF_GOOD_SOLD" },
      { label: "Other Income", value: "OTHER_INCOME" },
      { label: "Administration Expenses", value: "ADMINISTRATION_EXPENSES" },
      {
        label: "Selling & Distribution Expenses",
        value: "SELLING_DISTRIBUTION_EXPENSES",
      },
      { label: "Non-Current Asset", value: "NON_CURRENT_ASSET" },
      { label: "Current Asset", value: "CURRENT_ASSET" },
      { label: "Equity", value: "EQUITY" },
      { label: "Non-Current Liabilities", value: "NON_CURRENT_LIABILITIES" },
      { label: "Current Liabilities", value: "CURRENT_LIABILITIES" },
      { label: "Other Expenses", value: "OTHER_EXPENSES" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    layoutSettingList: [],
    totalRows: 0,

    queryParams: {
      name: "",
      code: "",
      layoutType: "",
      status: "",
      sessionName: "",
    },
    allLayoutSettingList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getLayoutSettingList();
      },
      deep: true,
    },
  },

  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.layoutType) {
      this.queryParams.layoutType = this.$route.query.layoutType;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.sessionName) {
      this.queryParams.sessionName = this.$route.query.sessionName;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getLayoutSettingList();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "layout-settings",
        query: this.queryParams,
      });
      this.getLayoutSettingList();
    },
    getLayoutSettingList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      layoutSettingService
        .getLayoutSettingList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.layoutSettingList = res.data.layoutSettingList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/layout-setting/new");
    },
    onEdit(layoutSetting) {
      // go to details page
      this.$router.push("/layout-setting/" + layoutSetting.id);
    },
    exportAllLayoutSetting() {
      this.buttonLoading = true;
      layoutSettingService
        .getLayoutSettingExcelExport(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    printAllLayoutSettingList(divName) {
      this.buttonLoading = true;
      layoutSettingService
        .getAllLayoutSettingList(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allLayoutSettingList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
  },
};
</script>